import ReportLayout from 'src/pages/Reports/Common/report/ReportLayout';
import ReportDetails from 'src/pages/Reports/Common/report/ReportDetails';

const TreeRemovalReport = () => (
  <ReportLayout title="Tree Removal Report">
    <ReportDetails
      title="Report Details"
      downloadEndpoint="tree_permit_application/download"
    />
  </ReportLayout>
);

export default TreeRemovalReport;
